/**
 * Pagination controls for the candidates table.
 */

import React from 'react';

interface CandidatePaginationProps {
  currentPage: number;
  totalPages: number;
  startIdx: number;
  endIdx: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

const btnStyle = (disabled: boolean): React.CSSProperties => ({
  padding: '6px 10px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  background: disabled ? '#f3f4f6' : 'white',
  color: disabled ? '#9ca3af' : '#374151',
  cursor: disabled ? 'default' : 'pointer',
  fontSize: '13px'
});

const CandidatePagination: React.FC<CandidatePaginationProps> = ({
  currentPage,
  totalPages,
  startIdx,
  endIdx,
  totalCount,
  onPageChange
}) => (
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    borderTop: '1px solid #e5e7eb',
    background: '#f9fafb',
    fontSize: '14px',
    color: '#374151'
  }}>
    <span>
      Showing {startIdx}\u2013{endIdx} of {totalCount}
    </span>
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <button
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        style={btnStyle(currentPage === 1)}
      >
        First
      </button>
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        style={btnStyle(currentPage === 1)}
      >
        Prev
      </button>
      <span style={{ padding: '0 12px', fontWeight: 600 }}>
        Page {currentPage} of {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        style={btnStyle(currentPage === totalPages)}
      >
        Next
      </button>
      <button
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        style={btnStyle(currentPage === totalPages)}
      >
        Last
      </button>
    </div>
  </div>
);

export default CandidatePagination;
